module.exports = __webpack_public_path__ + "62ef7d3c2fbd18594f919ff6100999cc.png";